import { HttpInterceptorFn } from "@angular/common/http";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const idToken = JSON.parse(localStorage.getItem('okta-token-storage') || '{}')?.idToken?.idToken;
  if (idToken) {
    req = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + idToken)
    });
  }

  return next(req);
}

